import * as React from "react";
const SvgFiBrandsAbbotLaboratories = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M20.812 2.4H0v3.198h19.773V5.6c.571 0 1.03.462 1.03 1.03v10.74l-.003.009a1.03 1.03 0 0 1-1.034 1.023H4.231a1.033 1.033 0 0 1-1.034-1.03v-4.344c0-.568.466-1.03 1.034-1.03h13.37V8.804H3.189A3.186 3.186 0 0 0 0 11.99v6.423a3.187 3.187 0 0 0 3.189 3.186h17.623A3.186 3.186 0 0 0 24 18.413V5.589A3.186 3.186 0 0 0 20.812 2.4"
    />
  </svg>
);
export default SvgFiBrandsAbbotLaboratories;
